export var TelemetryAgentParamType;
(function (TelemetryAgentParamType) {
    TelemetryAgentParamType["Boolean"] = "boolean";
    TelemetryAgentParamType["MultilinePattern"] = "multiline-pattern";
    TelemetryAgentParamType["PathList"] = "path-list";
    TelemetryAgentParamType["StringList"] = "string-list";
    TelemetryAgentParamType["SingleSelect"] = "single-select";
    TelemetryAgentParamType["MultiSelect"] = "multi-select";
    TelemetryAgentParamType["Text"] = "text";
    TelemetryAgentParamType["Number"] = "number";
    TelemetryAgentParamType["KeyValue"] = "key-value";
})(TelemetryAgentParamType || (TelemetryAgentParamType = {}));
export var TelemetryAgentInformationElementType;
(function (TelemetryAgentInformationElementType) {
    TelemetryAgentInformationElementType["Info"] = "info";
    TelemetryAgentInformationElementType["Announcement"] = "announcement";
})(TelemetryAgentInformationElementType || (TelemetryAgentInformationElementType = {}));
export var TelemetryAgentStatus;
(function (TelemetryAgentStatus) {
    TelemetryAgentStatus["Enabled"] = "ENABLED";
    TelemetryAgentStatus["Disabled"] = "DISABLED";
    TelemetryAgentStatus["Failed"] = "FAILED";
    TelemetryAgentStatus["Suspended"] = "SUSPENDED";
})(TelemetryAgentStatus || (TelemetryAgentStatus = {}));
export var TelemetryAgentIntegrationCapability;
(function (TelemetryAgentIntegrationCapability) {
    TelemetryAgentIntegrationCapability["SPM"] = "SPM";
})(TelemetryAgentIntegrationCapability || (TelemetryAgentIntegrationCapability = {}));
export var TelemetryAgentIntegrationType;
(function (TelemetryAgentIntegrationType) {
    TelemetryAgentIntegrationType["Fetcher"] = "FETCHER";
    TelemetryAgentIntegrationType["Agent"] = "AGENT";
})(TelemetryAgentIntegrationType || (TelemetryAgentIntegrationType = {}));
//# sourceMappingURL=enums.js.map